import _ from 'lodash';
let districts = [
  { jw_code: '10', amph_code: '01', name: 'เขตพระนคร', zipcode: '10200' },
  { jw_code: '10', amph_code: '02', name: 'เขตดุสิต', zipcode: '10300' },
  { jw_code: '10', amph_code: '03', name: 'เขตหนองจอก', zipcode: '10530' },
  { jw_code: '10', amph_code: '04', name: 'เขตบางรัก', zipcode: '10500' },
  { jw_code: '10', amph_code: '05', name: 'เขตบางเขน', zipcode: '10220' },
  { jw_code: '10', amph_code: '06', name: 'เขตบางกะปิ', zipcode: '10240' },
  { jw_code: '10', amph_code: '07', name: 'เขตปทุมวัน', zipcode: '10330' },
  { jw_code: '10', amph_code: '08', name: 'เขตป้อมปราบศัตรูพ่าย', zipcode: '10100' },
  { jw_code: '10', amph_code: '09', name: 'เขตพระโขนง', zipcode: '10260' },
  { jw_code: '10', amph_code: '10', name: 'เขตมีนบุรี', zipcode: '10510' },
  { jw_code: '10', amph_code: '11', name: 'เขตลาดกระบัง', zipcode: '10520' },
  { jw_code: '10', amph_code: '12', name: 'เขตยานนาวา', zipcode: '10120' },
  { jw_code: '10', amph_code: '13', name: 'เขตสัมพันธวงศ์', zipcode: '10100' },
  { jw_code: '10', amph_code: '14', name: 'เขตพญาไท', zipcode: '10400' },
  { jw_code: '10', amph_code: '15', name: 'เขตธนบุรี', zipcode: '10600' },
  { jw_code: '10', amph_code: '16', name: 'เขตบางกอกใหญ่', zipcode: '10600' },
  { jw_code: '10', amph_code: '17', name: 'เขตห้วยขวาง', zipcode: '10310' },
  { jw_code: '10', amph_code: '18', name: 'เขตคลองสาน', zipcode: '10600' },
  { jw_code: '10', amph_code: '19', name: 'เขตตลิ่งชัน', zipcode: '10170' },
  { jw_code: '10', amph_code: '20', name: 'เขตบางกอกน้อย', zipcode: '10700' },
  { jw_code: '10', amph_code: '21', name: 'เขตบางขุนเทียน', zipcode: '10150' },
  { jw_code: '10', amph_code: '22', name: 'เขตภาษีเจริญ', zipcode: '10160' },
  { jw_code: '10', amph_code: '23', name: 'เขตหนองแขม', zipcode: '10160' },
  { jw_code: '10', amph_code: '24', name: 'เขตราษฎร์บูรณะ', zipcode: '10140' },
  { jw_code: '10', amph_code: '25', name: 'เขตบางพลัด', zipcode: '10700' },
  { jw_code: '10', amph_code: '26', name: 'เขตดินแดง', zipcode: '10400' },
  { jw_code: '10', amph_code: '27', name: 'เขตบึงกุ่ม', zipcode: '10240' },
  { jw_code: '10', amph_code: '28', name: 'เขตสาทร', zipcode: '10120' },
  { jw_code: '10', amph_code: '29', name: 'เขตบางซื่อ', zipcode: '10800' },
  { jw_code: '10', amph_code: '30', name: 'เขตจตุจักร', zipcode: '10900' },
  { jw_code: '10', amph_code: '31', name: 'เขตบางคอแหลม', zipcode: '10120' },
  { jw_code: '10', amph_code: '32', name: 'เขตประเวศ', zipcode: '10250' },
  { jw_code: '10', amph_code: '33', name: 'เขตคลองเตย', zipcode: '10260' },
  { jw_code: '10', amph_code: '34', name: 'เขตสวนหลวง', zipcode: '10250' },
  { jw_code: '10', amph_code: '35', name: 'เขตจอมทอง', zipcode: '10150' },
  { jw_code: '10', amph_code: '36', name: 'เขตดอนเมือง', zipcode: '10210' },
  { jw_code: '10', amph_code: '37', name: 'เขตราชเทวี', zipcode: '10400' },
  { jw_code: '10', amph_code: '38', name: 'เขตลาดพร้าว', zipcode: '10230' },
  { jw_code: '10', amph_code: '39', name: 'เขตวัฒนา', zipcode: '10110' },
  { jw_code: '10', amph_code: '40', name: 'เขตบางแค', zipcode: '10160' },
  { jw_code: '10', amph_code: '41', name: 'เขตหลักสี่', zipcode: '10210' },
  { jw_code: '10', amph_code: '42', name: 'เขตสายไหม', zipcode: '10220' },
  { jw_code: '10', amph_code: '43', name: 'เขตคันนายาว', zipcode: '10230' },
  { jw_code: '10', amph_code: '44', name: 'สะพานสูง', zipcode: '10240' },
  { jw_code: '10', amph_code: '45', name: 'เขตวังทองหลาง', zipcode: '10310' },
  { jw_code: '10', amph_code: '46', name: 'เขตคลองสามวา', zipcode: '10510' },
  { jw_code: '10', amph_code: '47', name: 'เขตบางนา', zipcode: '10260' },
  { jw_code: '10', amph_code: '48', name: 'เขตทวีวัฒนา', zipcode: '10170' },
  { jw_code: '10', amph_code: '49', name: 'เขตทุ่งครุ', zipcode: '10140' },
  { jw_code: '10', amph_code: '50', name: 'เขตบางบอน', zipcode: '10150' },
  { jw_code: '11', amph_code: '01', name: 'เมือง', zipcode: '10270' },
  { jw_code: '11', amph_code: '02', name: 'บางบ่อ', zipcode: '10560' },
  { jw_code: '11', amph_code: '03', name: 'บางพลี', zipcode: '10540' },
  { jw_code: '11', amph_code: '04', name: 'พระประแดง', zipcode: '10130' },
  { jw_code: '11', amph_code: '05', name: 'พระสมุทรเจดีย์', zipcode: '10290' },
  { jw_code: '11', amph_code: '06', name: 'บางเสาธง', zipcode: '10540' },
  { jw_code: '12', amph_code: '01', name: 'เมือง', zipcode: '11000' },
  { jw_code: '12', amph_code: '02', name: 'บางกรวย', zipcode: '11130' },
  { jw_code: '12', amph_code: '03', name: 'บางใหญ่', zipcode: '11140' },
  { jw_code: '12', amph_code: '04', name: 'บางบัวทอง', zipcode: '11110' },
  { jw_code: '12', amph_code: '05', name: 'ไทรน้อย', zipcode: '11150' },
  { jw_code: '12', amph_code: '06', name: 'ปากเกร็ด', zipcode: '11120' },
  { jw_code: '13', amph_code: '01', name: 'เมือง', zipcode: '12000' },
  { jw_code: '13', amph_code: '02', name: 'คลองหลวง', zipcode: '12120' },
  { jw_code: '13', amph_code: '03', name: 'ธัญบุรี', zipcode: '12130' },
  { jw_code: '13', amph_code: '04', name: 'หนองเสือ', zipcode: '12170' },
  { jw_code: '13', amph_code: '05', name: 'ลาดหลุมแก้ว', zipcode: '12140' },
  { jw_code: '13', amph_code: '06', name: 'ลำลูกกา', zipcode: '12150' },
  { jw_code: '13', amph_code: '07', name: 'สามโคก', zipcode: '12160' },
  { jw_code: '14', amph_code: '01', name: 'พระนครศรีอยุธยา', zipcode: '13000' },
  { jw_code: '14', amph_code: '02', name: 'ท่าเรือ', zipcode: '13130' },
  { jw_code: '14', amph_code: '03', name: 'นครหลวง', zipcode: '13260' },
  { jw_code: '14', amph_code: '04', name: 'บางไทร', zipcode: '13190' },
  { jw_code: '14', amph_code: '05', name: 'บางบาล', zipcode: '13250' },
  { jw_code: '14', amph_code: '06', name: 'บางปะอิน', zipcode: '13160' },
  { jw_code: '14', amph_code: '07', name: 'บางปะหัน', zipcode: '13220' },
  { jw_code: '14', amph_code: '08', name: 'ผักไห่', zipcode: '13120' },
  { jw_code: '14', amph_code: '09', name: 'ภาชี', zipcode: '13140' },
  { jw_code: '14', amph_code: '10', name: 'ลาดบัวหลวง', zipcode: '13230' },
  { jw_code: '14', amph_code: '11', name: 'วังน้อย', zipcode: '13170' },
  { jw_code: '14', amph_code: '12', name: 'เสนา', zipcode: '13110' },
  { jw_code: '14', amph_code: '13', name: 'บางซ้าย', zipcode: '13270' },
  { jw_code: '14', amph_code: '14', name: 'อุทัย', zipcode: '13210' },
  { jw_code: '14', amph_code: '15', name: 'มหาราช', zipcode: '13150' },
  { jw_code: '14', amph_code: '16', name: 'บ้านแพรก', zipcode: '13240' },
  { jw_code: '15', amph_code: '01', name: 'เมือง', zipcode: '14000' },
  { jw_code: '15', amph_code: '02', name: 'ไชโย', zipcode: '14140' },
  { jw_code: '15', amph_code: '03', name: 'ป่าโมก', zipcode: '14130' },
  { jw_code: '15', amph_code: '04', name: 'โพธิ์ทอง', zipcode: '14120' },
  { jw_code: '15', amph_code: '05', name: 'แสวงหา', zipcode: '14150' },
  { jw_code: '15', amph_code: '06', name: 'วิเศษชัยชาญ', zipcode: '14110' },
  { jw_code: '15', amph_code: '07', name: 'สามโก้', zipcode: '14160' },
  { jw_code: '16', amph_code: '01', name: 'เมือง', zipcode: '15000' },
  { jw_code: '16', amph_code: '02', name: 'พัฒนานิคม', zipcode: '15140' },
  { jw_code: '16', amph_code: '03', name: 'โคกสำโรง', zipcode: '15120' },
  { jw_code: '16', amph_code: '04', name: 'ชัยบาดาล', zipcode: '15130' },
  { jw_code: '16', amph_code: '05', name: 'ท่าวุ้ง', zipcode: '15150' },
  { jw_code: '16', amph_code: '06', name: 'บ้านหมี่', zipcode: '15110' },
  { jw_code: '16', amph_code: '07', name: 'ท่าหลวง', zipcode: '15230' },
  { jw_code: '16', amph_code: '08', name: 'สระโบสถ์', zipcode: '15240' },
  { jw_code: '16', amph_code: '09', name: 'โคกเจริญ', zipcode: '15250' },
  { jw_code: '16', amph_code: '10', name: 'ลำสนธิ', zipcode: '15190' },
  { jw_code: '16', amph_code: '11', name: 'หนองม่วง', zipcode: '15170' },
  { jw_code: '17', amph_code: '01', name: 'เมือง', zipcode: '16000' },
  { jw_code: '17', amph_code: '02', name: 'บางระจัน', zipcode: '16130' },
  { jw_code: '17', amph_code: '03', name: 'ค่ายบางระจัน', zipcode: '16150' },
  { jw_code: '17', amph_code: '04', name: 'พรหมบุรี', zipcode: '16120' },
  { jw_code: '17', amph_code: '05', name: 'ท่าช้าง', zipcode: '16140' },
  { jw_code: '17', amph_code: '06', name: 'อินทร์บุรี', zipcode: '16110' },
  { jw_code: '18', amph_code: '01', name: 'เมือง', zipcode: '17000' },
  { jw_code: '18', amph_code: '02', name: 'มโนรมย์', zipcode: '17110' },
  { jw_code: '18', amph_code: '03', name: 'วัดสิงห์', zipcode: '17120' },
  { jw_code: '18', amph_code: '04', name: 'สรรพยา', zipcode: '17150' },
  { jw_code: '18', amph_code: '05', name: 'สรรคบุรี', zipcode: '17140' },
  { jw_code: '18', amph_code: '06', name: 'หันคา', zipcode: '17130' },
  { jw_code: '18', amph_code: '07', name: 'หนองมะโมง', zipcode: '17120' },
  { jw_code: '18', amph_code: '08', name: 'เนินขาม', zipcode: '17130' },
  { jw_code: '19', amph_code: '01', name: 'เมือง', zipcode: '18000' },
  { jw_code: '19', amph_code: '02', name: 'แก่งคอย', zipcode: '18110' },
  { jw_code: '19', amph_code: '03', name: 'หนองแค', zipcode: '18140' },
  { jw_code: '19', amph_code: '04', name: 'วิหารแดง', zipcode: '18150' },
  { jw_code: '19', amph_code: '05', name: 'หนองแซง', zipcode: '18170' },
  { jw_code: '19', amph_code: '06', name: 'บ้านหมอ', zipcode: '18130' },
  { jw_code: '19', amph_code: '07', name: 'ดอนพุด', zipcode: '18210' },
  { jw_code: '19', amph_code: '08', name: 'หนองโดน', zipcode: '18190' },
  { jw_code: '19', amph_code: '09', name: 'พระพุทธบาท', zipcode: '18120' },
  { jw_code: '19', amph_code: '10', name: 'เสาไห้', zipcode: '18160' },
  { jw_code: '19', amph_code: '11', name: 'มวกเหล็ก', zipcode: '18180' },
  { jw_code: '19', amph_code: '12', name: 'วังม่วง', zipcode: '18220' },
  { jw_code: '19', amph_code: '13', name: 'เฉลิมพระเกียรติ', zipcode: '18000' },
  { jw_code: '20', amph_code: '01', name: 'เมือง', zipcode: '20000' },
  { jw_code: '20', amph_code: '02', name: 'บ้านบึง', zipcode: '20170' },
  { jw_code: '20', amph_code: '03', name: 'หนองใหญ่', zipcode: '20190' },
  { jw_code: '20', amph_code: '04', name: 'บางละมุง', zipcode: '20150' },
  { jw_code: '20', amph_code: '05', name: 'พานทอง', zipcode: '20160' },
  { jw_code: '20', amph_code: '06', name: 'พนัสนิคม', zipcode: '20140' },
  { jw_code: '20', amph_code: '07', name: 'ศรีราชา', zipcode: '20110' },
  { jw_code: '20', amph_code: '08', name: 'เกาะสีชัง', zipcode: '20120' },
  { jw_code: '20', amph_code: '09', name: 'สัตหีบ', zipcode: '20180' },
  { jw_code: '20', amph_code: '10', name: 'บ่อทอง', zipcode: '20270' },
  { jw_code: '20', amph_code: '11', name: 'เกาะจันทร์', zipcode: '20240' },
  { jw_code: '21', amph_code: '01', name: 'เมือง', zipcode: '21000' },
  { jw_code: '21', amph_code: '02', name: 'บ้านฉาง', zipcode: '21130' },
  { jw_code: '21', amph_code: '03', name: 'แกลง', zipcode: '21110' },
  { jw_code: '21', amph_code: '04', name: 'วังจันทร์', zipcode: '21210' },
  { jw_code: '21', amph_code: '05', name: 'บ้านค่าย', zipcode: '21120' },
  { jw_code: '21', amph_code: '06', name: 'ปลวกแดง', zipcode: '21140' },
  { jw_code: '21', amph_code: '07', name: 'เขาชะเมา', zipcode: '21110' },
  { jw_code: '21', amph_code: '08', name: 'นิคมพัฒนา', zipcode: '21180' },
  { jw_code: '22', amph_code: '01', name: 'เมือง', zipcode: '22000' },
  { jw_code: '22', amph_code: '02', name: 'ขลุง', zipcode: '22110' },
  { jw_code: '22', amph_code: '03', name: 'ท่าใหม่', zipcode: '22120' },
  { jw_code: '22', amph_code: '04', name: 'โป่งน้ำร้อน', zipcode: '22140' },
  { jw_code: '22', amph_code: '05', name: 'มะขาม', zipcode: '22150' },
  { jw_code: '22', amph_code: '06', name: 'แหลมสิงห์', zipcode: '22130' },
  { jw_code: '22', amph_code: '07', name: 'สอยดาว', zipcode: '22180' },
  { jw_code: '22', amph_code: '08', name: 'แก่งหางแมว', zipcode: '22160' },
  { jw_code: '22', amph_code: '09', name: 'นายายอาม', zipcode: '22160' },
  { jw_code: '22', amph_code: '10', name: 'เขาคิชฌกูฎ', zipcode: '22210' },
  { jw_code: '23', amph_code: '01', name: 'เมือง', zipcode: '23000' },
  { jw_code: '23', amph_code: '02', name: 'คลองใหญ่', zipcode: '23110' },
  { jw_code: '23', amph_code: '03', name: 'เขาสมิง', zipcode: '23130' },
  { jw_code: '23', amph_code: '04', name: 'บ่อไร่', zipcode: '23140' },
  { jw_code: '23', amph_code: '05', name: 'แหลมงอบ', zipcode: '23120' },
  { jw_code: '23', amph_code: '06', name: 'เกาะกูด', zipcode: '23000' },
  { jw_code: '23', amph_code: '07', name: 'เกาะช้าง', zipcode: '23120' },
  { jw_code: '24', amph_code: '01', name: 'เมือง', zipcode: '24000' },
  { jw_code: '24', amph_code: '02', name: 'บางคล้า', zipcode: '24110' },
  { jw_code: '24', amph_code: '03', name: 'บางน้ำเปรี้ยว', zipcode: '24150' },
  { jw_code: '24', amph_code: '04', name: 'บางปะกง', zipcode: '24130' },
  { jw_code: '24', amph_code: '05', name: 'บ้านโพธิ์', zipcode: '24140' },
  { jw_code: '24', amph_code: '06', name: 'พนมสารคาม', zipcode: '24120' },
  { jw_code: '24', amph_code: '07', name: 'ราชสาส์น', zipcode: '24120' },
  { jw_code: '24', amph_code: '08', name: 'สนามชัยเขต', zipcode: '24160' },
  { jw_code: '24', amph_code: '09', name: 'แปลงยาว', zipcode: '24190' },
  { jw_code: '24', amph_code: '10', name: 'ท่าตะเกียบ', zipcode: '24160' },
  { jw_code: '24', amph_code: '11', name: 'คลองเขื่อน', zipcode: '24000' },
  { jw_code: '25', amph_code: '01', name: 'เมือง', zipcode: '25000' },
  { jw_code: '25', amph_code: '02', name: 'กบินทร์บุรี', zipcode: '25110' },
  { jw_code: '25', amph_code: '03', name: 'นาดี', zipcode: '25220' },
  { jw_code: '25', amph_code: '06', name: 'บ้านสร้าง', zipcode: '25150' },
  { jw_code: '25', amph_code: '07', name: 'ประจันตคาม', zipcode: '25130' },
  { jw_code: '25', amph_code: '08', name: 'ศรีมหาโพธิ', zipcode: '25140' },
  { jw_code: '25', amph_code: '09', name: 'ศรีมโหสถ', zipcode: '25190' },
  { jw_code: '26', amph_code: '01', name: 'เมือง', zipcode: '26000' },
  { jw_code: '26', amph_code: '02', name: 'ปากพลี', zipcode: '26130' },
  { jw_code: '26', amph_code: '03', name: 'บ้านนา', zipcode: '26110' },
  { jw_code: '26', amph_code: '04', name: 'องครักษ์', zipcode: '26120' },
  { jw_code: '27', amph_code: '01', name: 'เมือง', zipcode: '27000' },
  { jw_code: '27', amph_code: '02', name: 'คลองหาด', zipcode: '27260' },
  { jw_code: '27', amph_code: '03', name: 'ตาพระยา', zipcode: '27180' },
  { jw_code: '27', amph_code: '04', name: 'วังน้ำเย็น', zipcode: '27210' },
  { jw_code: '27', amph_code: '05', name: 'วัฒนานคร', zipcode: '27160' },
  { jw_code: '27', amph_code: '06', name: 'อรัญประเทศ', zipcode: '27120' },
  { jw_code: '27', amph_code: '07', name: 'เขาฉกรรจ์', zipcode: '27000' },
  { jw_code: '27', amph_code: '08', name: 'โคกสูง', zipcode: '27120' },
  { jw_code: '27', amph_code: '09', name: 'วังสมบูรณ์', zipcode: '27250' },
  { jw_code: '30', amph_code: '01', name: 'เมือง', zipcode: '30000' },
  { jw_code: '30', amph_code: '02', name: 'ครบุรี', zipcode: '30250' },
  { jw_code: '30', amph_code: '03', name: 'เสิงสาง', zipcode: '30330' },
  { jw_code: '30', amph_code: '04', name: 'คง', zipcode: '30260' },
  { jw_code: '30', amph_code: '05', name: 'บ้านเหลื่อม', zipcode: '30350' },
  { jw_code: '30', amph_code: '06', name: 'จักราช', zipcode: '30230' },
  { jw_code: '30', amph_code: '07', name: 'โชคชัย', zipcode: '30190' },
  { jw_code: '30', amph_code: '08', name: 'ด่านขุนทด', zipcode: '30210' },
  { jw_code: '30', amph_code: '09', name: 'โนนไทย', zipcode: '30220' },
  { jw_code: '30', amph_code: '10', name: 'โนนสูง', zipcode: '30160' },
  { jw_code: '30', amph_code: '11', name: 'ขามสะแกแสง', zipcode: '30290' },
  { jw_code: '30', amph_code: '12', name: 'บัวใหญ่', zipcode: '30120' },
  { jw_code: '30', amph_code: '13', name: 'ประทาย', zipcode: '30180' },
  { jw_code: '30', amph_code: '14', name: 'ปักธงชัย', zipcode: '30150' },
  { jw_code: '30', amph_code: '15', name: 'พิมาย', zipcode: '30110' },
  { jw_code: '30', amph_code: '16', name: 'ห้วยแถลง', zipcode: '30240' },
  { jw_code: '30', amph_code: '17', name: 'ชุมพวง', zipcode: '30270' },
  { jw_code: '30', amph_code: '18', name: 'สูงเนิน', zipcode: '30170' },
  { jw_code: '30', amph_code: '19', name: 'ขามทะเลสอ', zipcode: '30280' },
  { jw_code: '30', amph_code: '20', name: 'สีคิ้ว', zipcode: '30140' },
  { jw_code: '30', amph_code: '21', name: 'ปากช่อง', zipcode: '30130' },
  { jw_code: '30', amph_code: '22', name: 'หนองบุญมาก', zipcode: '30410' },
  { jw_code: '30', amph_code: '23', name: 'แก้งสนามนาง', zipcode: '30440' },
  { jw_code: '30', amph_code: '24', name: 'โนนแดง', zipcode: '30360' },
  { jw_code: '30', amph_code: '25', name: 'วังน้ำเขียว', zipcode: '30370' },
  { jw_code: '30', amph_code: '26', name: 'เทพารักษ์', zipcode: '30210' },
  { jw_code: '30', amph_code: '27', name: 'เมืองยาง', zipcode: '30270' },
  { jw_code: '30', amph_code: '28', name: 'พระทองคำ', zipcode: '30220' },
  { jw_code: '30', amph_code: '29', name: 'ลำทะเมนชัย', zipcode: '30270' },
  { jw_code: '30', amph_code: '30', name: 'บัวลาย', zipcode: '30120' },
  { jw_code: '30', amph_code: '31', name: 'สีดา', zipcode: '30430' },
  { jw_code: '30', amph_code: '32', name: 'เฉลิมพระเกียรติ', zipcode: '30270' },
  { jw_code: '31', amph_code: '01', name: 'เมือง', zipcode: '31000' },
  { jw_code: '31', amph_code: '02', name: 'คูเมือง', zipcode: '31190' },
  { jw_code: '31', amph_code: '03', name: 'กระสัง', zipcode: '31160' },
  { jw_code: '31', amph_code: '04', name: 'นางรอง', zipcode: '31110' },
  { jw_code: '31', amph_code: '05', name: 'หนองกี่', zipcode: '31210' },
  { jw_code: '31', amph_code: '06', name: 'ละหานทราย', zipcode: '31170' },
  { jw_code: '31', amph_code: '07', name: 'ประโคนชัย', zipcode: '31140' },
  { jw_code: '31', amph_code: '08', name: 'บ้านกรวด', zipcode: '31180' },
  { jw_code: '31', amph_code: '09', name: 'พุทไธสง', zipcode: '31120' },
  { jw_code: '31', amph_code: '10', name: 'ลำปลายมาศ', zipcode: '31130' },
  { jw_code: '31', amph_code: '11', name: 'สตึก', zipcode: '31150' },
  { jw_code: '31', amph_code: '12', name: 'ปะคำ', zipcode: '31220' },
  { jw_code: '31', amph_code: '13', name: 'นาโพธิ์', zipcode: '31230' },
  { jw_code: '31', amph_code: '14', name: 'หนองหงส์', zipcode: '31240' },
  { jw_code: '31', amph_code: '15', name: 'พลับพลาชัย', zipcode: '31250' },
  { jw_code: '31', amph_code: '16', name: 'ห้วยราช', zipcode: '31000' },
  { jw_code: '31', amph_code: '17', name: 'โนนสุวรรณ', zipcode: '31110' },
  { jw_code: '31', amph_code: '18', name: 'ชำนิ', zipcode: '31110' },
  { jw_code: '31', amph_code: '19', name: 'บ้านใหม่ไชยพจน์', zipcode: '31120' },
  { jw_code: '31', amph_code: '20', name: 'โนนดินแดง', zipcode: '31260' },
  { jw_code: '31', amph_code: '21', name: 'บ้านด่าน', zipcode: '31000' },
  { jw_code: '31', amph_code: '22', name: 'แคนดง', zipcode: '31150' },
  { jw_code: '31', amph_code: '23', name: 'เฉลิมพระเกียรติ', zipcode: '31110' },
  { jw_code: '32', amph_code: '01', name: 'เมือง', zipcode: '32000' },
  { jw_code: '32', amph_code: '02', name: 'ชุมพลบุรี', zipcode: '32190' },
  { jw_code: '32', amph_code: '03', name: 'ท่าตูม', zipcode: '32120' },
  { jw_code: '32', amph_code: '04', name: 'จอมพระ', zipcode: '32180' },
  { jw_code: '32', amph_code: '05', name: 'ปราสาท', zipcode: '32140' },
  { jw_code: '32', amph_code: '06', name: 'กาบเชิง', zipcode: '32210' },
  { jw_code: '32', amph_code: '07', name: 'รัตนบุรี', zipcode: '32130' },
  { jw_code: '32', amph_code: '08', name: 'สนม', zipcode: '32160' },
  { jw_code: '32', amph_code: '09', name: 'ศีขรภูมิ', zipcode: '32110' },
  { jw_code: '32', amph_code: '10', name: 'สังขะ', zipcode: '32150' },
  { jw_code: '32', amph_code: '11', name: 'ลำดวน', zipcode: '32220' },
  { jw_code: '32', amph_code: '12', name: 'สำโรงทาบ', zipcode: '32170' },
  { jw_code: '32', amph_code: '13', name: 'บัวเชด', zipcode: '32230' },
  { jw_code: '32', amph_code: '14', name: 'พนมดงรัก', zipcode: '32140' },
  { jw_code: '32', amph_code: '15', name: 'ศรีณรงค์', zipcode: '32150' },
  { jw_code: '32', amph_code: '16', name: 'เขวาสินรินทร์', zipcode: '32000' },
  { jw_code: '32', amph_code: '17', name: 'โนนนารายณ์', zipcode: '32130' },
  { jw_code: '33', amph_code: '01', name: 'เมือง', zipcode: '33000' },
  { jw_code: '33', amph_code: '02', name: 'ยางชุมน้อย', zipcode: '33190' },
  { jw_code: '33', amph_code: '03', name: 'กันทรารมย์', zipcode: '33130' },
  { jw_code: '33', amph_code: '04', name: 'กันทรลักษ์', zipcode: '33110' },
  { jw_code: '33', amph_code: '05', name: 'ขุขันธ์', zipcode: '33140' },
  { jw_code: '33', amph_code: '06', name: 'ไพรบึง', zipcode: '33180' },
  { jw_code: '33', amph_code: '07', name: 'ปรางค์กู่', zipcode: '33170' },
  { jw_code: '33', amph_code: '08', name: 'ขุนหาญ', zipcode: '33150' },
  { jw_code: '33', amph_code: '09', name: 'ราษีไศล', zipcode: '33160' },
  { jw_code: '33', amph_code: '10', name: 'อุทุมพรพิสัย', zipcode: '33120' },
  { jw_code: '33', amph_code: '11', name: 'บึงบูรพ์', zipcode: '33220' },
  { jw_code: '33', amph_code: '12', name: 'ห้วยทับทัน', zipcode: '33210' },
  { jw_code: '33', amph_code: '13', name: 'โนนคูณ', zipcode: '33250' },
  { jw_code: '33', amph_code: '14', name: 'ศรีรัตนะ', zipcode: '33240' },
  { jw_code: '33', amph_code: '15', name: 'น้ำเกลี้ยง', zipcode: '33130' },
  { jw_code: '33', amph_code: '16', name: 'วังหิน', zipcode: '33270' },
  { jw_code: '33', amph_code: '17', name: 'ภูสิงห์', zipcode: '33140' },
  { jw_code: '33', amph_code: '18', name: 'เมืองจันทร์', zipcode: '33120' },
  { jw_code: '33', amph_code: '19', name: 'เบญจลักษ์', zipcode: '33110' },
  { jw_code: '33', amph_code: '20', name: 'พยุห์', zipcode: '33230' },
  { jw_code: '33', amph_code: '21', name: 'โพธิ์ศรีสุวรรณ', zipcode: '33120' },
  { jw_code: '33', amph_code: '22', name: 'ศิลาลาด', zipcode: '33160' },
  { jw_code: '34', amph_code: '01', name: 'เมือง', zipcode: '34000' },
  { jw_code: '34', amph_code: '02', name: 'ศรีเมืองใหม่', zipcode: '34250' },
  { jw_code: '34', amph_code: '03', name: 'โขงเจียม', zipcode: '34220' },
  { jw_code: '34', amph_code: '04', name: 'เขื่องใน', zipcode: '34150' },
  { jw_code: '34', amph_code: '05', name: 'เขมราฐ', zipcode: '34170' },
  { jw_code: '34', amph_code: '07', name: 'เดชอุดม', zipcode: '34160' },
  { jw_code: '34', amph_code: '08', name: 'นาจะหลวย', zipcode: '34280' },
  { jw_code: '34', amph_code: '09', name: 'น้ำยืน', zipcode: '34260' },
  { jw_code: '34', amph_code: '10', name: 'บุณฑริก', zipcode: '34230' },
  { jw_code: '34', amph_code: '11', name: 'ตระการพืชผล', zipcode: '34130' },
  { jw_code: '34', amph_code: '12', name: 'กุดข้าวปุ้น', zipcode: '34270' },
  { jw_code: '34', amph_code: '14', name: 'ม่วงสามสิบ', zipcode: '34140' },
  { jw_code: '34', amph_code: '15', name: 'วารินชำราบ', zipcode: '34190' },
  { jw_code: '34', amph_code: '19', name: 'พิบูลมังสาหาร', zipcode: '34110' },
  { jw_code: '34', amph_code: '20', name: 'ตาลสุม', zipcode: '34330' },
  { jw_code: '34', amph_code: '21', name: 'โพธิ์ไทร', zipcode: '34340' },
  { jw_code: '34', amph_code: '22', name: 'สำโรง', zipcode: '34360' },
  { jw_code: '34', amph_code: '24', name: 'ดอนมดแดง', zipcode: '34000' },
  { jw_code: '34', amph_code: '25', name: 'สิรินธร', zipcode: '34350' },
  { jw_code: '34', amph_code: '26', name: 'ทุ่งศรีอุดม', zipcode: '34160' },
  { jw_code: '34', amph_code: '29', name: 'นาเยีย', zipcode: '34160' },
  { jw_code: '34', amph_code: '30', name: 'นาตาล', zipcode: '34170' },
  { jw_code: '34', amph_code: '31', name: 'เหล่าเสือโก้ก', zipcode: '34000' },
  { jw_code: '34', amph_code: '32', name: 'สว่างวีระวงศ์', zipcode: '34190' },
  { jw_code: '34', amph_code: '33', name: 'น้ำขุ่น', zipcode: '34260' },
  { jw_code: '35', amph_code: '01', name: 'เมือง', zipcode: '35000' },
  { jw_code: '35', amph_code: '02', name: 'ทรายมูล', zipcode: '35170' },
  { jw_code: '35', amph_code: '03', name: 'กุดชุม', zipcode: '35140' },
  { jw_code: '35', amph_code: '04', name: 'คำเขื่อนแก้ว', zipcode: '35110' },
  { jw_code: '35', amph_code: '05', name: 'ป่าติ้ว', zipcode: '35150' },
  { jw_code: '35', amph_code: '06', name: 'มหาชนะชัย', zipcode: '35130' },
  { jw_code: '35', amph_code: '07', name: 'ค้อวัง', zipcode: '35160' },
  { jw_code: '35', amph_code: '08', name: 'เลิงนกทา', zipcode: '35120' },
  { jw_code: '35', amph_code: '09', name: 'ไทยเจริญ', zipcode: '35120' },
  { jw_code: '36', amph_code: '01', name: 'เมือง', zipcode: '36000' },
  { jw_code: '36', amph_code: '02', name: 'บ้านเขว้า', zipcode: '36170' },
  { jw_code: '36', amph_code: '03', name: 'คอนสวรรค์', zipcode: '36140' },
  { jw_code: '36', amph_code: '04', name: 'เกษตรสมบูรณ์', zipcode: '36120' },
  { jw_code: '36', amph_code: '05', name: 'หนองบัวแดง', zipcode: '36210' },
  { jw_code: '36', amph_code: '06', name: 'จัตุรัส', zipcode: '36130' },
  { jw_code: '36', amph_code: '07', name: 'บำเหน็จณรงค์', zipcode: '36160' },
  { jw_code: '36', amph_code: '08', name: 'หนองบัวระเหว', zipcode: '36250' },
  { jw_code: '36', amph_code: '09', name: 'เทพสถิต', zipcode: '36230' },
  { jw_code: '36', amph_code: '10', name: 'ภูเขียว', zipcode: '36110' },
  { jw_code: '36', amph_code: '11', name: 'บ้านแท่น', zipcode: '36190' },
  { jw_code: '36', amph_code: '12', name: 'แก้งคร้อ', zipcode: '36150' },
  { jw_code: '36', amph_code: '13', name: 'คอนสาร', zipcode: '36180' },
  { jw_code: '36', amph_code: '14', name: 'ภักดีชุมพล', zipcode: '36260' },
  { jw_code: '36', amph_code: '15', name: 'เนินสง่า', zipcode: '36130' },
  { jw_code: '36', amph_code: '16', name: 'ซับใหญ่', zipcode: '36130' },
  { jw_code: '37', amph_code: '01', name: 'เมือง', zipcode: '37000' },
  { jw_code: '37', amph_code: '02', name: 'ชานุมาน', zipcode: '37210' },
  { jw_code: '37', amph_code: '03', name: 'ปทุมราชวงศา', zipcode: '37110' },
  { jw_code: '37', amph_code: '04', name: 'พนา', zipcode: '37180' },
  { jw_code: '37', amph_code: '05', name: 'เสนางคนิคม', zipcode: '37290' },
  { jw_code: '37', amph_code: '06', name: 'หัวตะพาน', zipcode: '37240' },
  { jw_code: '37', amph_code: '07', name: 'ลืออำนาจ', zipcode: '37000' },
  { jw_code: '38', amph_code: '01', name: 'เมืองบึงกาฬ', zipcode: '38000' },
  { jw_code: '38', amph_code: '02', name: 'พรเจริญ', zipcode: '38180' },
  { jw_code: '38', amph_code: '03', name: 'โซ่พิสัย', zipcode: '38170' },
  { jw_code: '38', amph_code: '04', name: 'เซกา', zipcode: '38150' },
  { jw_code: '38', amph_code: '05', name: 'ปากคาด', zipcode: '38190' },
  { jw_code: '38', amph_code: '06', name: 'บึงโขงหลง', zipcode: '38220' },
  { jw_code: '38', amph_code: '07', name: 'ศรีวิไล', zipcode: '38210' },
  { jw_code: '38', amph_code: '08', name: 'บุ่งคล้า', zipcode: '38000' },
  { jw_code: '39', amph_code: '01', name: 'เมือง', zipcode: '39000' },
  { jw_code: '39', amph_code: '02', name: 'นากลาง', zipcode: '39170' },
  { jw_code: '39', amph_code: '03', name: 'โนนสัง', zipcode: '39140' },
  { jw_code: '39', amph_code: '04', name: 'ศรีบุญเรือง', zipcode: '39180' },
  { jw_code: '39', amph_code: '05', name: 'สุวรรณคูหา', zipcode: '39270' },
  { jw_code: '39', amph_code: '06', name: 'นาวัง', zipcode: '39170' },
  { jw_code: '40', amph_code: '01', name: 'เมือง', zipcode: '40000' },
  { jw_code: '40', amph_code: '02', name: 'บ้านฝาง', zipcode: '40270' },
  { jw_code: '40', amph_code: '03', name: 'พระยืน', zipcode: '40320' },
  { jw_code: '40', amph_code: '04', name: 'หนองเรือ', zipcode: '40210' },
  { jw_code: '40', amph_code: '05', name: 'ชุมแพ', zipcode: '40130' },
  { jw_code: '40', amph_code: '06', name: 'สีชมพู', zipcode: '40220' },
  { jw_code: '40', amph_code: '07', name: 'น้ำพอง', zipcode: '40140' },
  { jw_code: '40', amph_code: '08', name: 'อุบลรัตน์', zipcode: '40250' },
  { jw_code: '40', amph_code: '09', name: 'กระนวน', zipcode: '40170' },
  { jw_code: '40', amph_code: '10', name: 'บ้านไผ่', zipcode: '40110' },
  { jw_code: '40', amph_code: '11', name: 'เปือยน้อย', zipcode: '40340' },
  { jw_code: '40', amph_code: '12', name: 'พล', zipcode: '40120' },
  { jw_code: '40', amph_code: '13', name: 'แวงใหญ่', zipcode: '40330' },
  { jw_code: '40', amph_code: '14', name: 'แวงน้อย', zipcode: '40230' },
  { jw_code: '40', amph_code: '15', name: 'หนองสองห้อง', zipcode: '40190' },
  { jw_code: '40', amph_code: '16', name: 'ภูเวียง', zipcode: '40150' },
  { jw_code: '40', amph_code: '17', name: 'มัญจาคีรี', zipcode: '40160' },
  { jw_code: '40', amph_code: '18', name: 'ชนบท', zipcode: '40180' },
  { jw_code: '40', amph_code: '19', name: 'เขาสวนกวาง', zipcode: '40280' },
  { jw_code: '40', amph_code: '20', name: 'ภูผาม่าน', zipcode: '40350' },
  { jw_code: '40', amph_code: '21', name: 'ชำสูง', zipcode: '40170' },
  { jw_code: '40', amph_code: '22', name: 'โคกโพธิ์ไชย', zipcode: '40160' },
  { jw_code: '40', amph_code: '23', name: 'หนองนาคำ', zipcode: '40150' },
  { jw_code: '40', amph_code: '24', name: 'บ้านแฮด', zipcode: '40110' },
  { jw_code: '40', amph_code: '25', name: 'โนนศิลา', zipcode: '40110' },
  { jw_code: '40', amph_code: '29', name: 'เวียงเก่า', zipcode: '40150' },
  { jw_code: '41', amph_code: '01', name: 'เมือง', zipcode: '41000' },
  { jw_code: '41', amph_code: '02', name: 'กุดจับ', zipcode: '41250' },
  { jw_code: '41', amph_code: '03', name: 'หนองวัวซอ', zipcode: '41220' },
  { jw_code: '41', amph_code: '04', name: 'กุมภวาปี', zipcode: '41110' },
  { jw_code: '41', amph_code: '05', name: 'โนนสะอาด', zipcode: '41240' },
  { jw_code: '41', amph_code: '06', name: 'หนองหาน', zipcode: '41130' },
  { jw_code: '41', amph_code: '07', name: 'ทุ่งฝน', zipcode: '41310' },
  { jw_code: '41', amph_code: '08', name: 'ไชยวาน', zipcode: '41290' },
  { jw_code: '41', amph_code: '09', name: 'ศรีธาตุ', zipcode: '41230' },
  { jw_code: '41', amph_code: '10', name: 'วังสามหมอ', zipcode: '41280' },
  { jw_code: '41', amph_code: '11', name: 'บ้านดุง', zipcode: '41190' },
  { jw_code: '41', amph_code: '17', name: 'บ้านผือ', zipcode: '41160' },
  { jw_code: '41', amph_code: '18', name: 'น้ำโสม', zipcode: '41210' },
  { jw_code: '41', amph_code: '19', name: 'เพ็ญ', zipcode: '41150' },
  { jw_code: '41', amph_code: '20', name: 'สร้างคอม', zipcode: '41260' },
  { jw_code: '41', amph_code: '21', name: 'หนองแสง', zipcode: '41340' },
  { jw_code: '41', amph_code: '22', name: 'นายูง', zipcode: '41380' },
  { jw_code: '41', amph_code: '23', name: 'พิบูลย์รักษ์', zipcode: '41130' },
  { jw_code: '41', amph_code: '24', name: 'กู่แก้ว', zipcode: '41130' },
  { jw_code: '41', amph_code: '25', name: 'ประจักษ์ศิลปาคม', zipcode: '41110' },
  { jw_code: '42', amph_code: '01', name: 'เมือง', zipcode: '42000' },
  { jw_code: '42', amph_code: '02', name: 'นาด้วง', zipcode: '42210' },
  { jw_code: '42', amph_code: '03', name: 'เชียงคาน', zipcode: '42110' },
  { jw_code: '42', amph_code: '04', name: 'ปากชม', zipcode: '42150' },
  { jw_code: '42', amph_code: '05', name: 'ด่านซ้าย', zipcode: '42120' },
  { jw_code: '42', amph_code: '06', name: 'นาแห้ว', zipcode: '42170' },
  { jw_code: '42', amph_code: '07', name: 'ภูเรือ', zipcode: '42160' },
  { jw_code: '42', amph_code: '08', name: 'ท่าลี่', zipcode: '42140' },
  { jw_code: '42', amph_code: '09', name: 'วังสะพุง', zipcode: '42130' },
  { jw_code: '42', amph_code: '10', name: 'ภูกระดึง', zipcode: '42180' },
  { jw_code: '42', amph_code: '11', name: 'ภูหลวง', zipcode: '42230' },
  { jw_code: '42', amph_code: '12', name: 'ผาขาว', zipcode: '42240' },
  { jw_code: '42', amph_code: '13', name: 'เอราวัณ', zipcode: '42220' },
  { jw_code: '42', amph_code: '14', name: 'หนองหิน', zipcode: '42190' },
  { jw_code: '43', amph_code: '01', name: 'เมือง', zipcode: '43000' },
  { jw_code: '43', amph_code: '02', name: 'ท่าบ่อ', zipcode: '43110' },
  { jw_code: '43', amph_code: '05', name: 'โพนพิสัย', zipcode: '43120' },
  { jw_code: '43', amph_code: '07', name: 'ศรีเชียงใหม่', zipcode: '43130' },
  { jw_code: '43', amph_code: '08', name: 'สังคม', zipcode: '43160' },
  { jw_code: '43', amph_code: '14', name: 'สระใคร่', zipcode: '43100' },
  { jw_code: '43', amph_code: '15', name: 'เฝ้าไร่', zipcode: '43120' },
  { jw_code: '43', amph_code: '16', name: 'รัตนวาปี', zipcode: '43120' },
  { jw_code: '43', amph_code: '17', name: 'โพธิ์ตาก', zipcode: '43130' },
  { jw_code: '44', amph_code: '01', name: 'เมือง', zipcode: '44000' },
  { jw_code: '44', amph_code: '02', name: 'แกดำ', zipcode: '44190' },
  { jw_code: '44', amph_code: '03', name: 'โกสุมพิสัย', zipcode: '44140' },
  { jw_code: '44', amph_code: '04', name: 'กันทรวิชัย', zipcode: '44150' },
  { jw_code: '44', amph_code: '05', name: 'เชียงยืน', zipcode: '44160' },
  { jw_code: '44', amph_code: '06', name: 'บรบือ', zipcode: '44130' },
  { jw_code: '44', amph_code: '07', name: 'นาเชือก', zipcode: '44170' },
  { jw_code: '44', amph_code: '08', name: 'พยัคฆภูมิพิสัย', zipcode: '44110' },
  { jw_code: '44', amph_code: '09', name: 'วาปีปทุม', zipcode: '44120' },
  { jw_code: '44', amph_code: '10', name: 'นาดูน', zipcode: '44180' },
  { jw_code: '44', amph_code: '11', name: 'ยางสีสุราช', zipcode: '44210' },
  { jw_code: '44', amph_code: '12', name: 'กุดรัง', zipcode: '44130' },
  { jw_code: '44', amph_code: '13', name: 'ชื่นชม', zipcode: '44160' },
  { jw_code: '45', amph_code: '01', name: 'เมือง', zipcode: '45000' },
  { jw_code: '45', amph_code: '02', name: 'เกษตรวิสัย', zipcode: '45150' },
  { jw_code: '45', amph_code: '03', name: 'ปทุมรัตต์', zipcode: '45190' },
  { jw_code: '45', amph_code: '04', name: 'จตุรพักตรพิมาน', zipcode: '45180' },
  { jw_code: '45', amph_code: '05', name: 'ธวัชบุรี', zipcode: '45170' },
  { jw_code: '45', amph_code: '06', name: 'พนมไพร', zipcode: '45140' },
  { jw_code: '45', amph_code: '07', name: 'โพนทอง', zipcode: '45110' },
  { jw_code: '45', amph_code: '08', name: 'โพธิ์ชัย', zipcode: '45230' },
  { jw_code: '45', amph_code: '09', name: 'หนองพอก', zipcode: '45210' },
  { jw_code: '45', amph_code: '10', name: 'เสลภูมิ', zipcode: '45120' },
  { jw_code: '45', amph_code: '11', name: 'สุวรรณภูมิ', zipcode: '45130' },
  { jw_code: '45', amph_code: '12', name: 'เมืองสรวง', zipcode: '45220' },
  { jw_code: '45', amph_code: '13', name: 'โพนทราย', zipcode: '45240' },
  { jw_code: '45', amph_code: '14', name: 'อาจสามารถ', zipcode: '45160' },
  { jw_code: '45', amph_code: '15', name: 'เมยวดี', zipcode: '45250' },
  { jw_code: '45', amph_code: '16', name: 'ศรีสมเด็จ', zipcode: '45000' },
  { jw_code: '45', amph_code: '17', name: 'จังหาร', zipcode: '45000' },
  { jw_code: '45', amph_code: '18', name: 'เชียงขวัญ', zipcode: '45000' },
  { jw_code: '45', amph_code: '19', name: 'หนองฮี', zipcode: '45140' },
  { jw_code: '45', amph_code: '20', name: 'ทุ่งเขาหลวง', zipcode: '45170' },
  { jw_code: '46', amph_code: '01', name: 'เมือง', zipcode: '46000' },
  { jw_code: '46', amph_code: '02', name: 'นามน', zipcode: '46230' },
  { jw_code: '46', amph_code: '03', name: 'กมลาไสย', zipcode: '46130' },
  { jw_code: '46', amph_code: '04', name: 'ร่องคำ', zipcode: '46210' },
  { jw_code: '46', amph_code: '05', name: 'กุฉินารายณ์', zipcode: '46110' },
  { jw_code: '46', amph_code: '06', name: 'เขาวง', zipcode: '46160' },
  { jw_code: '46', amph_code: '07', name: 'ยางตลาด', zipcode: '46120' },
  { jw_code: '46', amph_code: '08', name: 'ห้วยเม็ก', zipcode: '46170' },
  { jw_code: '46', amph_code: '09', name: 'สหัสขันธ์', zipcode: '46140' },
  { jw_code: '46', amph_code: '10', name: 'คำม่วง', zipcode: '46180' },
  { jw_code: '46', amph_code: '11', name: 'ท่าคันโท', zipcode: '46190' },
  { jw_code: '46', amph_code: '12', name: 'หนองกุงศรี', zipcode: '46220' },
  { jw_code: '46', amph_code: '13', name: 'สมเด็จ', zipcode: '46150' },
  { jw_code: '46', amph_code: '14', name: 'ห้วยผึ้ง', zipcode: '46240' },
  { jw_code: '46', amph_code: '15', name: 'สามชัย', zipcode: '46180' },
  { jw_code: '46', amph_code: '16', name: 'นาคู', zipcode: '46160' },
  { jw_code: '46', amph_code: '17', name: 'ดอนจาน', zipcode: '46000' },
  { jw_code: '46', amph_code: '18', name: 'ฆ้องชัย', zipcode: '46130' },
  { jw_code: '47', amph_code: '01', name: 'เมือง', zipcode: '47000' },
  { jw_code: '47', amph_code: '02', name: 'กุสุมาลย์', zipcode: '47210' },
  { jw_code: '47', amph_code: '03', name: 'กุดบาก', zipcode: '47180' },
  { jw_code: '47', amph_code: '04', name: 'พรรณานิคม', zipcode: '47130' },
  { jw_code: '47', amph_code: '05', name: 'พังโคน', zipcode: '47160' },
  { jw_code: '47', amph_code: '06', name: 'วาริชภูมิ', zipcode: '47150' },
  { jw_code: '47', amph_code: '07', name: 'นิคมน้ำอูน', zipcode: '47270' },
  { jw_code: '47', amph_code: '08', name: 'วานรนิวาส', zipcode: '47120' },
  { jw_code: '47', amph_code: '09', name: 'คำตากล้า', zipcode: '47250' },
  { jw_code: '47', amph_code: '10', name: 'บ้านม่วง', zipcode: '47140' },
  { jw_code: '47', amph_code: '11', name: 'อากาศอำนวย', zipcode: '47170' },
  { jw_code: '47', amph_code: '12', name: 'สว่างแดนดิน', zipcode: '47110' },
  { jw_code: '47', amph_code: '13', name: 'ส่องดาว', zipcode: '47190' },
  { jw_code: '47', amph_code: '14', name: 'เต่างอย', zipcode: '47260' },
  { jw_code: '47', amph_code: '15', name: 'โคกศรีสุพรรณ', zipcode: '47280' },
  { jw_code: '47', amph_code: '16', name: 'เจริญศิลป์', zipcode: '47290' },
  { jw_code: '47', amph_code: '17', name: 'โพนนาแก้ว', zipcode: '47230' },
  { jw_code: '47', amph_code: '18', name: 'ภูพาน', zipcode: '47180' },
  { jw_code: '48', amph_code: '01', name: 'เมือง', zipcode: '48000' },
  { jw_code: '48', amph_code: '02', name: 'ปลาปาก', zipcode: '48160' },
  { jw_code: '48', amph_code: '03', name: 'ท่าอุเทน', zipcode: '48120' },
  { jw_code: '48', amph_code: '04', name: 'บ้านแพง', zipcode: '48140' },
  { jw_code: '48', amph_code: '05', name: 'ธาตุพนม', zipcode: '48110' },
  { jw_code: '48', amph_code: '06', name: 'เรณูนคร', zipcode: '48170' },
  { jw_code: '48', amph_code: '07', name: 'นาแก', zipcode: '48130' },
  { jw_code: '48', amph_code: '08', name: 'ศรีสงคราม', zipcode: '48150' },
  { jw_code: '48', amph_code: '09', name: 'นาหว้า', zipcode: '48180' },
  { jw_code: '48', amph_code: '10', name: 'โพนสวรรค์', zipcode: '48190' },
  { jw_code: '48', amph_code: '11', name: 'นาทม', zipcode: '48140' },
  { jw_code: '48', amph_code: '12', name: 'วังยาง', zipcode: '48130' },
  { jw_code: '49', amph_code: '01', name: 'เมือง', zipcode: '49000' },
  { jw_code: '49', amph_code: '02', name: 'นิคมคำสร้อย', zipcode: '49130' },
  { jw_code: '49', amph_code: '03', name: 'ดอนตาล', zipcode: '49120' },
  { jw_code: '49', amph_code: '04', name: 'ดงหลวง', zipcode: '49140' },
  { jw_code: '49', amph_code: '05', name: 'คำชะอี', zipcode: '49110' },
  { jw_code: '49', amph_code: '06', name: 'หว้านใหญ่', zipcode: '49150' },
  { jw_code: '49', amph_code: '07', name: 'หนองสูง', zipcode: '49160' },
  { jw_code: '50', amph_code: '01', name: 'เมือง', zipcode: '50000' },
  { jw_code: '50', amph_code: '02', name: 'จอมทอง', zipcode: '50160' },
  { jw_code: '50', amph_code: '03', name: 'แม่แจ่ม', zipcode: '50270' },
  { jw_code: '50', amph_code: '04', name: 'เชียงดาว', zipcode: '50170' },
  { jw_code: '50', amph_code: '05', name: 'ดอยสะเก็ด', zipcode: '50220' },
  { jw_code: '50', amph_code: '06', name: 'แม่แตง', zipcode: '50150' },
  { jw_code: '50', amph_code: '07', name: 'แม่ริม', zipcode: '50180' },
  { jw_code: '50', amph_code: '08', name: 'สะเมิง', zipcode: '50250' },
  { jw_code: '50', amph_code: '09', name: 'ฝาง', zipcode: '50110' },
  { jw_code: '50', amph_code: '10', name: 'แม่อาย', zipcode: '50280' },
  { jw_code: '50', amph_code: '11', name: 'พร้าว', zipcode: '50190' },
  { jw_code: '50', amph_code: '12', name: 'สันป่าตอง', zipcode: '50120' },
  { jw_code: '50', amph_code: '13', name: 'สันกำแพง', zipcode: '50130' },
  { jw_code: '50', amph_code: '14', name: 'สันทราย', zipcode: '50210' },
  { jw_code: '50', amph_code: '15', name: 'หางดง', zipcode: '50230' },
  { jw_code: '50', amph_code: '16', name: 'ฮอด', zipcode: '50240' },
  { jw_code: '50', amph_code: '17', name: 'ดอยเต่า', zipcode: '50260' },
  { jw_code: '50', amph_code: '18', name: 'อมก๋อย', zipcode: '50310' },
  { jw_code: '50', amph_code: '19', name: 'สารภี', zipcode: '50140' },
  { jw_code: '50', amph_code: '20', name: 'เวียงแหง', zipcode: '50350' },
  { jw_code: '50', amph_code: '21', name: 'ไชยปราการ', zipcode: '50320' },
  { jw_code: '50', amph_code: '22', name: 'แม่วาง', zipcode: '50360' },
  { jw_code: '50', amph_code: '23', name: 'แม่ออน', zipcode: '50130' },
  { jw_code: '50', amph_code: '24', name: 'ดอยหล่อ', zipcode: '50160' },
  { jw_code: '50', amph_code: '25', name: 'กัลยาณิวัฒนา', zipcode: '50270' },
  { jw_code: '51', amph_code: '01', name: 'เมือง', zipcode: '51000' },
  { jw_code: '51', amph_code: '02', name: 'แม่ทา', zipcode: '51140' },
  { jw_code: '51', amph_code: '03', name: 'บ้านโฮ่ง', zipcode: '51130' },
  { jw_code: '51', amph_code: '04', name: 'ลี้', zipcode: '51110' },
  { jw_code: '51', amph_code: '05', name: 'ทุ่งหัวช้าง', zipcode: '51160' },
  { jw_code: '51', amph_code: '06', name: 'ป่าซาง', zipcode: '51120' },
  { jw_code: '51', amph_code: '07', name: 'บ้านธิ', zipcode: '51180' },
  { jw_code: '51', amph_code: '08', name: 'เวียงหนองล่อง', zipcode: '51120' },
  { jw_code: '52', amph_code: '01', name: 'เมือง', zipcode: '52000' },
  { jw_code: '52', amph_code: '02', name: 'แม่เมาะ', zipcode: '52220' },
  { jw_code: '52', amph_code: '03', name: 'เกาะคา', zipcode: '52130' },
  { jw_code: '52', amph_code: '04', name: 'เสริมงาม', zipcode: '52210' },
  { jw_code: '52', amph_code: '05', name: 'งาว', zipcode: '52110' },
  { jw_code: '52', amph_code: '06', name: 'แจ้ห่ม', zipcode: '52120' },
  { jw_code: '52', amph_code: '07', name: 'วังเหนือ', zipcode: '52140' },
  { jw_code: '52', amph_code: '08', name: 'เถิน', zipcode: '52160' },
  { jw_code: '52', amph_code: '09', name: 'แม่พริก', zipcode: '52180' },
  { jw_code: '52', amph_code: '10', name: 'แม่ทะ', zipcode: '52150' },
  { jw_code: '52', amph_code: '11', name: 'สบปราบ', zipcode: '52170' },
  { jw_code: '52', amph_code: '12', name: 'ห้างฉัตร', zipcode: '52190' },
  { jw_code: '52', amph_code: '13', name: 'เมืองปาน', zipcode: '52240' },
  { jw_code: '53', amph_code: '01', name: 'เมือง', zipcode: '53000' },
  { jw_code: '53', amph_code: '02', name: 'ตรอน', zipcode: '53140' },
  { jw_code: '53', amph_code: '03', name: 'ท่าปลา', zipcode: '53150' },
  { jw_code: '53', amph_code: '04', name: 'น้ำปาด', zipcode: '53110' },
  { jw_code: '53', amph_code: '05', name: 'ฟากท่า', zipcode: '53160' },
  { jw_code: '53', amph_code: '06', name: 'บ้านโคก', zipcode: '53180' },
  { jw_code: '53', amph_code: '07', name: 'พิชัย', zipcode: '53120' },
  { jw_code: '53', amph_code: '08', name: 'ลับแล', zipcode: '53130' },
  { jw_code: '53', amph_code: '09', name: 'ทองแสนขัน', zipcode: '53230' },
  { jw_code: '54', amph_code: '01', name: 'เมือง', zipcode: '54000' },
  { jw_code: '54', amph_code: '02', name: 'ร้องกวาง', zipcode: '54140' },
  { jw_code: '54', amph_code: '03', name: 'ลอง', zipcode: '54150' },
  { jw_code: '54', amph_code: '04', name: 'สูงเม่น', zipcode: '54130' },
  { jw_code: '54', amph_code: '05', name: 'เด่นชัย', zipcode: '54110' },
  { jw_code: '54', amph_code: '06', name: 'สอง', zipcode: '54120' },
  { jw_code: '54', amph_code: '07', name: 'วังชิ้น', zipcode: '54160' },
  { jw_code: '54', amph_code: '08', name: 'หนองม่วงไข่', zipcode: '54170' },
  { jw_code: '55', amph_code: '01', name: 'เมือง', zipcode: '55000' },
  { jw_code: '55', amph_code: '02', name: 'แม่จริม', zipcode: '55170' },
  { jw_code: '55', amph_code: '03', name: 'บ้านหลวง', zipcode: '55190' },
  { jw_code: '55', amph_code: '04', name: 'นาน้อย', zipcode: '55150' },
  { jw_code: '55', amph_code: '05', name: 'ปัว', zipcode: '55120' },
  { jw_code: '55', amph_code: '06', name: 'ท่าวังผา', zipcode: '55140' },
  { jw_code: '55', amph_code: '07', name: 'เวียงสา', zipcode: '55110' },
  { jw_code: '55', amph_code: '08', name: 'ทุ่งช้าง', zipcode: '55130' },
  { jw_code: '55', amph_code: '09', name: 'เชียงกลาง', zipcode: '55160' },
  { jw_code: '55', amph_code: '10', name: 'นาหมื่น', zipcode: '55180' },
  { jw_code: '55', amph_code: '11', name: 'สันติสุข', zipcode: '55210' },
  { jw_code: '55', amph_code: '12', name: 'บ่อเกลือ', zipcode: '55220' },
  { jw_code: '55', amph_code: '13', name: 'สองแคว', zipcode: '55160' },
  { jw_code: '55', amph_code: '14', name: 'ภูเพียง', zipcode: '55000' },
  { jw_code: '55', amph_code: '15', name: 'เฉลิมพระเกียรติ', zipcode: '55130' },
  { jw_code: '56', amph_code: '01', name: 'เมือง', zipcode: '56000' },
  { jw_code: '56', amph_code: '02', name: 'จุน', zipcode: '56150' },
  { jw_code: '56', amph_code: '03', name: 'เชียงคำ', zipcode: '56110' },
  { jw_code: '56', amph_code: '04', name: 'เชียงม่วน', zipcode: '56160' },
  { jw_code: '56', amph_code: '05', name: 'ดอกคำใต้', zipcode: '56120' },
  { jw_code: '56', amph_code: '06', name: 'ปง', zipcode: '56140' },
  { jw_code: '56', amph_code: '07', name: 'แม่ใจ', zipcode: '56130' },
  { jw_code: '56', amph_code: '08', name: 'ภูซาง', zipcode: '56110' },
  { jw_code: '56', amph_code: '09', name: 'ภูกามยาว', zipcode: '56000' },
  { jw_code: '57', amph_code: '01', name: 'เมือง', zipcode: '57000' },
  { jw_code: '57', amph_code: '02', name: 'เวียงชัย', zipcode: '57210' },
  { jw_code: '57', amph_code: '03', name: 'เชียงของ', zipcode: '57140' },
  { jw_code: '57', amph_code: '04', name: 'เทิง', zipcode: '57160' },
  { jw_code: '57', amph_code: '05', name: 'พาน', zipcode: '57120' },
  { jw_code: '57', amph_code: '06', name: 'ป่าแดด', zipcode: '57190' },
  { jw_code: '57', amph_code: '07', name: 'แม่จัน', zipcode: '57110' },
  { jw_code: '57', amph_code: '08', name: 'เชียงแสน', zipcode: '57150' },
  { jw_code: '57', amph_code: '09', name: 'แม่สาย', zipcode: '57130' },
  { jw_code: '57', amph_code: '10', name: 'แม่สรวย', zipcode: '57180' },
  { jw_code: '57', amph_code: '11', name: 'เวียงป่าเป้า', zipcode: '57170' },
  { jw_code: '57', amph_code: '12', name: 'พญาเม็งราย', zipcode: '57290' },
  { jw_code: '57', amph_code: '13', name: 'เวียงแก่น', zipcode: '57310' },
  { jw_code: '57', amph_code: '14', name: 'ขุนตาล', zipcode: '57340' },
  { jw_code: '57', amph_code: '15', name: 'แม่ฟ้าหลวง', zipcode: '57110' },
  { jw_code: '57', amph_code: '16', name: 'แม่ลาว', zipcode: '57250' },
  { jw_code: '57', amph_code: '17', name: 'เวียงเชียงรุ้ง', zipcode: '57210' },
  { jw_code: '57', amph_code: '18', name: 'ดอยหลวง', zipcode: '57110' },
  { jw_code: '58', amph_code: '01', name: 'เมือง', zipcode: '58000' },
  { jw_code: '58', amph_code: '02', name: 'ขุนยวม', zipcode: '58140' },
  { jw_code: '58', amph_code: '03', name: 'ปาย', zipcode: '58130' },
  { jw_code: '58', amph_code: '04', name: 'แม่สะเรียง', zipcode: '58110' },
  { jw_code: '58', amph_code: '05', name: 'แม่ลาน้อย', zipcode: '58120' },
  { jw_code: '58', amph_code: '06', name: 'สบเมย', zipcode: '58110' },
  { jw_code: '58', amph_code: '07', name: 'ปางมะผ้า', zipcode: '58150' },
  { jw_code: '60', amph_code: '01', name: 'เมือง', zipcode: '60000' },
  { jw_code: '60', amph_code: '02', name: 'โกรกพระ', zipcode: '60170' },
  { jw_code: '60', amph_code: '03', name: 'ชุมแสง', zipcode: '60120' },
  { jw_code: '60', amph_code: '04', name: 'หนองบัว', zipcode: '60110' },
  { jw_code: '60', amph_code: '05', name: 'บรรพตพิสัย', zipcode: '60180' },
  { jw_code: '60', amph_code: '06', name: 'เก้าเลี้ยว', zipcode: '60230' },
  { jw_code: '60', amph_code: '07', name: 'ตาคลี', zipcode: '60140' },
  { jw_code: '60', amph_code: '08', name: 'ท่าตะโก', zipcode: '60160' },
  { jw_code: '60', amph_code: '09', name: 'ไพศาลี', zipcode: '60220' },
  { jw_code: '60', amph_code: '10', name: 'พยุหะคีรี', zipcode: '60130' },
  { jw_code: '60', amph_code: '11', name: 'ลาดยาว', zipcode: '60150' },
  { jw_code: '60', amph_code: '12', name: 'ตากฟ้า', zipcode: '60190' },
  { jw_code: '60', amph_code: '13', name: 'แม่วงก์', zipcode: '60150' },
  { jw_code: '60', amph_code: '14', name: 'แม่เปิน', zipcode: '60150' },
  { jw_code: '60', amph_code: '15', name: 'ชุมตาบง', zipcode: '60150' },
  { jw_code: '61', amph_code: '01', name: 'เมือง', zipcode: '61000' },
  { jw_code: '61', amph_code: '02', name: 'ทัพทัน', zipcode: '61120' },
  { jw_code: '61', amph_code: '03', name: 'สว่างอารมณ์', zipcode: '61150' },
  { jw_code: '61', amph_code: '04', name: 'หนองฉาง', zipcode: '61110' },
  { jw_code: '61', amph_code: '05', name: 'หนองขาหย่าง', zipcode: '61130' },
  { jw_code: '61', amph_code: '06', name: 'บ้านไร่', zipcode: '61140' },
  { jw_code: '61', amph_code: '07', name: 'ลานสัก', zipcode: '61160' },
  { jw_code: '61', amph_code: '08', name: 'ห้วยคต', zipcode: '61170' },
  { jw_code: '62', amph_code: '01', name: 'เมือง', zipcode: '62000' },
  { jw_code: '62', amph_code: '02', name: 'ไทรงาม', zipcode: '62150' },
  { jw_code: '62', amph_code: '03', name: 'คลองลาน', zipcode: '62180' },
  { jw_code: '62', amph_code: '04', name: 'ขาณุวรลักษบุรี', zipcode: '62130' },
  { jw_code: '62', amph_code: '05', name: 'คลองขลุง', zipcode: '62120' },
  { jw_code: '62', amph_code: '06', name: 'พรานกระต่าย', zipcode: '62110' },
  { jw_code: '62', amph_code: '07', name: 'ลานกระบือ', zipcode: '62170' },
  { jw_code: '62', amph_code: '08', name: 'ทรายทองวัฒนา', zipcode: '62190' },
  { jw_code: '62', amph_code: '09', name: 'ปางศิลาทอง', zipcode: '62120' },
  { jw_code: '62', amph_code: '10', name: 'บึงสามัคคี', zipcode: '62210' },
  { jw_code: '62', amph_code: '11', name: 'โกสัมพีนคร', zipcode: '62000' },
  { jw_code: '63', amph_code: '01', name: 'เมือง', zipcode: '63000' },
  { jw_code: '63', amph_code: '02', name: 'บ้านตาก', zipcode: '63120' },
  { jw_code: '63', amph_code: '03', name: 'สามเงา', zipcode: '63130' },
  { jw_code: '63', amph_code: '04', name: 'แม่ระมาด', zipcode: '63140' },
  { jw_code: '63', amph_code: '05', name: 'ท่าสองยาง', zipcode: '63150' },
  { jw_code: '63', amph_code: '06', name: 'แม่สอด', zipcode: '63110' },
  { jw_code: '63', amph_code: '07', name: 'พบพระ', zipcode: '63160' },
  { jw_code: '63', amph_code: '08', name: 'อุ้มผาง', zipcode: '63170' },
  { jw_code: '63', amph_code: '09', name: 'วังเจ้า', zipcode: '63000' },
  { jw_code: '64', amph_code: '01', name: 'เมือง', zipcode: '64000' },
  { jw_code: '64', amph_code: '02', name: 'บ้านด่านลานหอย', zipcode: '64140' },
  { jw_code: '64', amph_code: '03', name: 'คีรีมาศ', zipcode: '64160' },
  { jw_code: '64', amph_code: '04', name: 'กงไกรลาศ', zipcode: '64170' },
  { jw_code: '64', amph_code: '05', name: 'ศรีสัชนาลัย', zipcode: '64130' },
  { jw_code: '64', amph_code: '06', name: 'ศรีสำโรง', zipcode: '64120' },
  { jw_code: '64', amph_code: '07', name: 'สวรรคโลก', zipcode: '64110' },
  { jw_code: '64', amph_code: '08', name: 'ศรีนคร', zipcode: '64180' },
  { jw_code: '64', amph_code: '09', name: 'ทุ่งเสลี่ยม', zipcode: '64150' },
  { jw_code: '65', amph_code: '01', name: 'เมือง', zipcode: '65000' },
  { jw_code: '65', amph_code: '02', name: 'นครไทย', zipcode: '65120' },
  { jw_code: '65', amph_code: '03', name: 'ชาติตระการ', zipcode: '65170' },
  { jw_code: '65', amph_code: '04', name: 'บางระกำ', zipcode: '65140' },
  { jw_code: '65', amph_code: '05', name: 'บางกระทุ่ม', zipcode: '65110' },
  { jw_code: '65', amph_code: '06', name: 'พรหมพิราม', zipcode: '65150' },
  { jw_code: '65', amph_code: '07', name: 'วัดโบสถ์', zipcode: '65160' },
  { jw_code: '65', amph_code: '08', name: 'วังทอง', zipcode: '65130' },
  { jw_code: '65', amph_code: '09', name: 'เนินมะปราง', zipcode: '65190' },
  { jw_code: '66', amph_code: '01', name: 'เมือง', zipcode: '66000' },
  { jw_code: '66', amph_code: '02', name: 'วังทรายพูน', zipcode: '66180' },
  { jw_code: '66', amph_code: '03', name: 'โพธิ์ประทับช้าง', zipcode: '66190' },
  { jw_code: '66', amph_code: '04', name: 'ตะพานหิน', zipcode: '66110' },
  { jw_code: '66', amph_code: '05', name: 'บางมูลนาก', zipcode: '66120' },
  { jw_code: '66', amph_code: '06', name: 'โพทะเล', zipcode: '66130' },
  { jw_code: '66', amph_code: '07', name: 'สามง่าม', zipcode: '66140' },
  { jw_code: '66', amph_code: '08', name: 'ทับคล้อ', zipcode: '66150' },
  { jw_code: '66', amph_code: '09', name: 'สากเหล็ก', zipcode: '66160' },
  { jw_code: '66', amph_code: '10', name: 'บึงนาราง', zipcode: '66130' },
  { jw_code: '66', amph_code: '11', name: 'ดงเจริญ', zipcode: '66210' },
  { jw_code: '66', amph_code: '12', name: 'วชิรบารมี', zipcode: '66140' },
  { jw_code: '67', amph_code: '01', name: 'เมือง', zipcode: '67000' },
  { jw_code: '67', amph_code: '02', name: 'ชนแดน', zipcode: '67150' },
  { jw_code: '67', amph_code: '03', name: 'หล่มสัก', zipcode: '67110' },
  { jw_code: '67', amph_code: '04', name: 'หล่มเก่า', zipcode: '67120' },
  { jw_code: '67', amph_code: '05', name: 'วิเชียรบุรี', zipcode: '67130' },
  { jw_code: '67', amph_code: '06', name: 'ศรีเทพ', zipcode: '67170' },
  { jw_code: '67', amph_code: '07', name: 'หนองไผ่', zipcode: '67140' },
  { jw_code: '67', amph_code: '08', name: 'บึงสามพัน', zipcode: '67160' },
  { jw_code: '67', amph_code: '09', name: 'น้ำหนาว', zipcode: '67260' },
  { jw_code: '67', amph_code: '10', name: 'วังโป่ง', zipcode: '67240' },
  { jw_code: '67', amph_code: '11', name: 'เขาค้อ', zipcode: '67270' },
  { jw_code: '70', amph_code: '01', name: 'เมือง', zipcode: '70000' },
  { jw_code: '70', amph_code: '02', name: 'จอมบึง', zipcode: '70150' },
  { jw_code: '70', amph_code: '03', name: 'สวนผึ้ง', zipcode: '70180' },
  { jw_code: '70', amph_code: '04', name: 'ดำเนินสะดวก', zipcode: '70130' },
  { jw_code: '70', amph_code: '05', name: 'บ้านโป่ง', zipcode: '70110' },
  { jw_code: '70', amph_code: '06', name: 'บางแพ', zipcode: '70160' },
  { jw_code: '70', amph_code: '07', name: 'โพธาราม', zipcode: '70120' },
  { jw_code: '70', amph_code: '08', name: 'ปากท่อ', zipcode: '70140' },
  { jw_code: '70', amph_code: '09', name: 'วัดเพลง', zipcode: '70170' },
  { jw_code: '70', amph_code: '10', name: 'บ้านคา', zipcode: '70180' },
  { jw_code: '71', amph_code: '01', name: 'เมือง', zipcode: '71000' },
  { jw_code: '71', amph_code: '02', name: 'ไทรโยค', zipcode: '71150' },
  { jw_code: '71', amph_code: '03', name: 'บ่อพลอย', zipcode: '71160' },
  { jw_code: '71', amph_code: '04', name: 'ศรีสวัสดิ์', zipcode: '71250' },
  { jw_code: '71', amph_code: '05', name: 'ท่ามะกา', zipcode: '71120' },
  { jw_code: '71', amph_code: '06', name: 'ท่าม่วง', zipcode: '71110' },
  { jw_code: '71', amph_code: '07', name: 'ทองผาภูมิ', zipcode: '71180' },
  { jw_code: '71', amph_code: '08', name: 'สังขละบุรี', zipcode: '71240' },
  { jw_code: '71', amph_code: '09', name: 'พนมทวน', zipcode: '71140' },
  { jw_code: '71', amph_code: '10', name: 'เลาขวัญ', zipcode: '71210' },
  { jw_code: '71', amph_code: '11', name: 'ด่านมะขามเตี้ย', zipcode: '71260' },
  { jw_code: '71', amph_code: '12', name: 'หนองปรือ', zipcode: '71220' },
  { jw_code: '71', amph_code: '13', name: 'ห้วยกระเจา', zipcode: '71170' },
  { jw_code: '72', amph_code: '01', name: 'เมือง', zipcode: '72000' },
  { jw_code: '72', amph_code: '02', name: 'เดิมบางนางบวช', zipcode: '72120' },
  { jw_code: '72', amph_code: '03', name: 'ด่านช้าง', zipcode: '72180' },
  { jw_code: '72', amph_code: '04', name: 'บางปลาม้า', zipcode: '72150' },
  { jw_code: '72', amph_code: '05', name: 'ศรีประจันต์', zipcode: '72140' },
  { jw_code: '72', amph_code: '06', name: 'ดอนเจดีย์', zipcode: '72170' },
  { jw_code: '72', amph_code: '07', name: 'สองพี่น้อง', zipcode: '72110' },
  { jw_code: '72', amph_code: '08', name: 'สามชุก', zipcode: '72130' },
  { jw_code: '72', amph_code: '09', name: 'อู่ทอง', zipcode: '72160' },
  { jw_code: '72', amph_code: '10', name: 'หนองหญ้าไซ', zipcode: '72240' },
  { jw_code: '73', amph_code: '01', name: 'เมือง', zipcode: '73000' },
  { jw_code: '73', amph_code: '02', name: 'กำแพงแสน', zipcode: '73140' },
  { jw_code: '73', amph_code: '03', name: 'นครชัยศรี', zipcode: '73120' },
  { jw_code: '73', amph_code: '04', name: 'ดอนตูม', zipcode: '73150' },
  { jw_code: '73', amph_code: '05', name: 'บางเลน', zipcode: '73130' },
  { jw_code: '73', amph_code: '06', name: 'สามพราน', zipcode: '73110' },
  { jw_code: '73', amph_code: '07', name: 'พุทธมณฑล', zipcode: '73170' },
  { jw_code: '74', amph_code: '01', name: 'เมือง', zipcode: '74000' },
  { jw_code: '74', amph_code: '02', name: 'กระทุ่มแบน', zipcode: '74110' },
  { jw_code: '74', amph_code: '03', name: 'บ้านแพ้ว', zipcode: '74120' },
  { jw_code: '75', amph_code: '01', name: 'เมือง', zipcode: '75000' },
  { jw_code: '75', amph_code: '02', name: 'บางคนที', zipcode: '75120' },
  { jw_code: '75', amph_code: '03', name: 'อัมพวา', zipcode: '75110' },
  { jw_code: '76', amph_code: '01', name: 'เมือง', zipcode: '76000' },
  { jw_code: '76', amph_code: '02', name: 'เขาย้อย', zipcode: '76140' },
  { jw_code: '76', amph_code: '03', name: 'หนองหญ้าปล้อง', zipcode: '76160' },
  { jw_code: '76', amph_code: '04', name: 'ชะอำ', zipcode: '76120' },
  { jw_code: '76', amph_code: '05', name: 'ท่ายาง', zipcode: '76130' },
  { jw_code: '76', amph_code: '06', name: 'บ้านลาด', zipcode: '76150' },
  { jw_code: '76', amph_code: '07', name: 'บ้านแหลม', zipcode: '76110' },
  { jw_code: '76', amph_code: '08', name: 'แก่งกระจาน', zipcode: '76170' },
  { jw_code: '77', amph_code: '01', name: 'เมือง', zipcode: '77000' },
  { jw_code: '77', amph_code: '02', name: 'กุยบุรี', zipcode: '77150' },
  { jw_code: '77', amph_code: '03', name: 'ทับสะแก', zipcode: '77130' },
  { jw_code: '77', amph_code: '04', name: 'บางสะพาน', zipcode: '77140' },
  { jw_code: '77', amph_code: '05', name: 'บางสะพานน้อย', zipcode: '77170' },
  { jw_code: '77', amph_code: '06', name: 'ปราณบุรี', zipcode: '77120' },
  { jw_code: '77', amph_code: '07', name: 'หัวหิน', zipcode: '77110' },
  { jw_code: '77', amph_code: '08', name: 'สามร้อยยอด', zipcode: '77180' },
  { jw_code: '80', amph_code: '01', name: 'เมือง', zipcode: '80000' },
  { jw_code: '80', amph_code: '02', name: 'พรหมคีรี', zipcode: '80320' },
  { jw_code: '80', amph_code: '03', name: 'ลานสกา', zipcode: '80230' },
  { jw_code: '80', amph_code: '04', name: 'ฉวาง', zipcode: '80150' },
  { jw_code: '80', amph_code: '05', name: 'พิปูน', zipcode: '80270' },
  { jw_code: '80', amph_code: '06', name: 'เชียรใหญ่', zipcode: '80190' },
  { jw_code: '80', amph_code: '07', name: 'ชะอวด', zipcode: '80180' },
  { jw_code: '80', amph_code: '08', name: 'ท่าศาลา', zipcode: '80160' },
  { jw_code: '80', amph_code: '09', name: 'ทุ่งสง', zipcode: '80110' },
  { jw_code: '80', amph_code: '10', name: 'นาบอน', zipcode: '80220' },
  { jw_code: '80', amph_code: '11', name: 'ทุ่งใหญ่', zipcode: '80240' },
  { jw_code: '80', amph_code: '12', name: 'ปากพนัง', zipcode: '80140' },
  { jw_code: '80', amph_code: '13', name: 'ร่อนพิบูลย์', zipcode: '80130' },
  { jw_code: '80', amph_code: '14', name: 'สิชล', zipcode: '80120' },
  { jw_code: '80', amph_code: '15', name: 'ขนอม', zipcode: '80210' },
  { jw_code: '80', amph_code: '16', name: 'หัวไทร', zipcode: '80170' },
  { jw_code: '80', amph_code: '17', name: 'บางขัน', zipcode: '80360' },
  { jw_code: '80', amph_code: '18', name: 'ถ้ำพรรณรา', zipcode: '80260' },
  { jw_code: '80', amph_code: '19', name: 'จุฬาภรณ์', zipcode: '80130' },
  { jw_code: '80', amph_code: '20', name: 'พระพรหม', zipcode: '80000' },
  { jw_code: '80', amph_code: '21', name: 'นบพิตำ', zipcode: '80160' },
  { jw_code: '80', amph_code: '22', name: 'ช้างกลาง', zipcode: '80190' },
  { jw_code: '80', amph_code: '23', name: 'เฉลิมพระเกียรติ', zipcode: '80250' },
  { jw_code: '81', amph_code: '01', name: 'เมือง', zipcode: '81000' },
  { jw_code: '81', amph_code: '02', name: 'เขาพนม', zipcode: '81140' },
  { jw_code: '81', amph_code: '03', name: 'เกาะลันตา', zipcode: '81150' },
  { jw_code: '81', amph_code: '04', name: 'คลองท่อม', zipcode: '81120' },
  { jw_code: '81', amph_code: '05', name: 'อ่าวลึก', zipcode: '81110' },
  { jw_code: '81', amph_code: '06', name: 'ปลายพระยา', zipcode: '81160' },
  { jw_code: '81', amph_code: '07', name: 'ลำทับ', zipcode: '81120' },
  { jw_code: '81', amph_code: '08', name: 'เหนือคลอง', zipcode: '81130' },
  { jw_code: '82', amph_code: '01', name: 'เมือง', zipcode: '82000' },
  { jw_code: '82', amph_code: '02', name: 'เกาะยาว', zipcode: '82160' },
  { jw_code: '82', amph_code: '03', name: 'กะปง', zipcode: '82170' },
  { jw_code: '82', amph_code: '04', name: 'ตะกั่วทุ่ง', zipcode: '82130' },
  { jw_code: '82', amph_code: '05', name: 'ตะกั่วป่า', zipcode: '82110' },
  { jw_code: '82', amph_code: '06', name: 'คุระบุรี', zipcode: '82150' },
  { jw_code: '82', amph_code: '07', name: 'ทับปุด', zipcode: '82180' },
  { jw_code: '82', amph_code: '08', name: 'ท้ายเหมือง', zipcode: '82120' },
  { jw_code: '83', amph_code: '01', name: 'เมือง', zipcode: '83000' },
  { jw_code: '83', amph_code: '02', name: 'กะทู้', zipcode: '83120' },
  { jw_code: '83', amph_code: '03', name: 'ถลาง', zipcode: '83110' },
  { jw_code: '84', amph_code: '01', name: 'เมือง', zipcode: '84000' },
  { jw_code: '84', amph_code: '02', name: 'กาญจนดิษฐ์', zipcode: '84160' },
  { jw_code: '84', amph_code: '03', name: 'ดอนสัก', zipcode: '84220' },
  { jw_code: '84', amph_code: '04', name: 'เกาะสมุย', zipcode: '84140' },
  { jw_code: '84', amph_code: '05', name: 'เกาะพะงัน', zipcode: '84280' },
  { jw_code: '84', amph_code: '06', name: 'ไชยา', zipcode: '84110' },
  { jw_code: '84', amph_code: '07', name: 'ท่าชนะ', zipcode: '84170' },
  { jw_code: '84', amph_code: '08', name: 'คีรีรัฐนิคม', zipcode: '84180' },
  { jw_code: '84', amph_code: '09', name: 'บ้านตาขุน', zipcode: '84230' },
  { jw_code: '84', amph_code: '10', name: 'พนม', zipcode: '84250' },
  { jw_code: '84', amph_code: '11', name: 'ท่าฉาง', zipcode: '84150' },
  { jw_code: '84', amph_code: '12', name: 'บ้านนาสาร', zipcode: '84120' },
  { jw_code: '84', amph_code: '13', name: 'บ้านนาเดิม', zipcode: '84240' },
  { jw_code: '84', amph_code: '14', name: 'เคียนซา', zipcode: '84260' },
  { jw_code: '84', amph_code: '15', name: 'เวียงสระ', zipcode: '84190' },
  { jw_code: '84', amph_code: '16', name: 'พระแสง', zipcode: '84210' },
  { jw_code: '84', amph_code: '17', name: 'พุนพิน', zipcode: '84130' },
  { jw_code: '84', amph_code: '18', name: 'ชัยบุรี', zipcode: '84350' },
  { jw_code: '84', amph_code: '19', name: 'วิภาวดี', zipcode: '84180' },
  { jw_code: '85', amph_code: '01', name: 'เมือง', zipcode: '85000' },
  { jw_code: '85', amph_code: '02', name: 'ละอุ่น', zipcode: '85130' },
  { jw_code: '85', amph_code: '03', name: 'กะเปอร์', zipcode: '85120' },
  { jw_code: '85', amph_code: '04', name: 'กระบุรี', zipcode: '85110' },
  { jw_code: '85', amph_code: '05', name: 'สุขสำราญ', zipcode: '85120' },
  { jw_code: '86', amph_code: '01', name: 'เมือง', zipcode: '86000' },
  { jw_code: '86', amph_code: '02', name: 'ท่าแซะ', zipcode: '86140' },
  { jw_code: '86', amph_code: '03', name: 'ปะทิว', zipcode: '86160' },
  { jw_code: '86', amph_code: '04', name: 'หลังสวน', zipcode: '86110' },
  { jw_code: '86', amph_code: '05', name: 'ละแม', zipcode: '86170' },
  { jw_code: '86', amph_code: '06', name: 'พะโต๊ะ', zipcode: '86180' },
  { jw_code: '86', amph_code: '07', name: 'สวี', zipcode: '86130' },
  { jw_code: '86', amph_code: '08', name: 'ทุ่งตะโก', zipcode: '86220' },
  { jw_code: '90', amph_code: '01', name: 'เมือง', zipcode: '90000' },
  { jw_code: '90', amph_code: '02', name: 'สทิงพระ', zipcode: '90190' },
  { jw_code: '90', amph_code: '03', name: 'จะนะ', zipcode: '90130' },
  { jw_code: '90', amph_code: '04', name: 'นาทวี', zipcode: '90160' },
  { jw_code: '90', amph_code: '05', name: 'เทพา', zipcode: '90150' },
  { jw_code: '90', amph_code: '06', name: 'สะบ้าย้อย', zipcode: '90210' },
  { jw_code: '90', amph_code: '07', name: 'ระโนด', zipcode: '90140' },
  { jw_code: '90', amph_code: '08', name: 'กระแสสินธุ์', zipcode: '90270' },
  { jw_code: '90', amph_code: '09', name: 'รัตภูมิ', zipcode: '90180' },
  { jw_code: '90', amph_code: '10', name: 'สะเดา', zipcode: '90120' },
  { jw_code: '90', amph_code: '11', name: 'หาดใหญ่', zipcode: '90110' },
  { jw_code: '90', amph_code: '12', name: 'นาหม่อม', zipcode: '90310' },
  { jw_code: '90', amph_code: '13', name: 'ควนเนียง', zipcode: '90220' },
  { jw_code: '90', amph_code: '14', name: 'บางกล่ำ', zipcode: '90110' },
  { jw_code: '90', amph_code: '15', name: 'สิงหนคร', zipcode: '90280' },
  { jw_code: '90', amph_code: '16', name: 'คลองหอยโข่ง', zipcode: '90230' },
  { jw_code: '91', amph_code: '01', name: 'เมือง', zipcode: '91000' },
  { jw_code: '91', amph_code: '02', name: 'ควนโดน', zipcode: '91160' },
  { jw_code: '91', amph_code: '03', name: 'ควนกาหลง', zipcode: '91130' },
  { jw_code: '91', amph_code: '04', name: 'ท่าแพ', zipcode: '91150' },
  { jw_code: '91', amph_code: '05', name: 'ละงู', zipcode: '91110' },
  { jw_code: '91', amph_code: '06', name: 'ทุ่งหว้า', zipcode: '91120' },
  { jw_code: '91', amph_code: '07', name: 'มะนัง', zipcode: '91130' },
  { jw_code: '92', amph_code: '01', name: 'เมือง', zipcode: '92000' },
  { jw_code: '92', amph_code: '02', name: 'กันตัง', zipcode: '92110' },
  { jw_code: '92', amph_code: '03', name: 'ย่านตาขาว', zipcode: '92140' },
  { jw_code: '92', amph_code: '04', name: 'ปะเหลียน', zipcode: '92120' },
  { jw_code: '92', amph_code: '05', name: 'สิเกา', zipcode: '92150' },
  { jw_code: '92', amph_code: '06', name: 'ห้วยยอด', zipcode: '92130' },
  { jw_code: '92', amph_code: '07', name: 'วังวิเศษ', zipcode: '92220' },
  { jw_code: '92', amph_code: '08', name: 'นาโยง', zipcode: '92170' },
  { jw_code: '92', amph_code: '09', name: 'รัษฎา', zipcode: '92160' },
  { jw_code: '92', amph_code: '10', name: 'หาดสำราญ', zipcode: '92120' },
  { jw_code: '93', amph_code: '01', name: 'เมือง', zipcode: '93000' },
  { jw_code: '93', amph_code: '02', name: 'กงหรา', zipcode: '93180' },
  { jw_code: '93', amph_code: '03', name: 'เขาชัยสน', zipcode: '93130' },
  { jw_code: '93', amph_code: '04', name: 'ตะโหมด', zipcode: '93160' },
  { jw_code: '93', amph_code: '05', name: 'ควนขนุน', zipcode: '93110' },
  { jw_code: '93', amph_code: '06', name: 'ปากพะยูน', zipcode: '93120' },
  { jw_code: '93', amph_code: '07', name: 'ศรีบรรพต', zipcode: '93190' },
  { jw_code: '93', amph_code: '08', name: 'ป่าบอน', zipcode: '93170' },
  { jw_code: '93', amph_code: '09', name: 'บางแก้ว', zipcode: '93140' },
  { jw_code: '93', amph_code: '10', name: 'ป่าพะยอม', zipcode: '93110' },
  { jw_code: '93', amph_code: '11', name: 'ศรีนครินทร์', zipcode: '93000' },
  { jw_code: '94', amph_code: '01', name: 'เมือง', zipcode: '94000' },
  { jw_code: '94', amph_code: '02', name: 'โคกโพธิ์', zipcode: '94120' },
  { jw_code: '94', amph_code: '03', name: 'หนองจิก', zipcode: '94170' },
  { jw_code: '94', amph_code: '04', name: 'ปะนาเระ', zipcode: '94130' },
  { jw_code: '94', amph_code: '05', name: 'มายอ', zipcode: '94140' },
  { jw_code: '94', amph_code: '06', name: 'ทุ่งยางแดง', zipcode: '94230' },
  { jw_code: '94', amph_code: '07', name: 'สายบุรี', zipcode: '94110' },
  { jw_code: '94', amph_code: '08', name: 'ไม้แก่น', zipcode: '94220' },
  { jw_code: '94', amph_code: '09', name: 'ยะหริ่ง', zipcode: '94150' },
  { jw_code: '94', amph_code: '10', name: 'ยะรัง', zipcode: '94160' },
  { jw_code: '94', amph_code: '11', name: 'กะพ้อ', zipcode: '94140' },
  { jw_code: '94', amph_code: '12', name: 'แม่ลาน', zipcode: '94180' },
  { jw_code: '95', amph_code: '01', name: 'เมือง', zipcode: '95000' },
  { jw_code: '95', amph_code: '02', name: 'เบตง', zipcode: '95110' },
  { jw_code: '95', amph_code: '03', name: 'บันนังสตา', zipcode: '95130' },
  { jw_code: '95', amph_code: '04', name: 'ธารโต', zipcode: '95150' },
  { jw_code: '95', amph_code: '05', name: 'ยะหา', zipcode: '95120' },
  { jw_code: '95', amph_code: '06', name: 'รามัน', zipcode: '95140' },
  { jw_code: '95', amph_code: '07', name: 'กาบัง', zipcode: '95120' },
  { jw_code: '95', amph_code: '08', name: 'กรงปีนัง', zipcode: '95000' },
  { jw_code: '96', amph_code: '01', name: 'เมือง', zipcode: '96000' },
  { jw_code: '96', amph_code: '02', name: 'ตากใบ', zipcode: '96110' },
  { jw_code: '96', amph_code: '03', name: 'บาเจาะ', zipcode: '96170' },
  { jw_code: '96', amph_code: '04', name: 'ยี่งอ', zipcode: '96180' },
  { jw_code: '96', amph_code: '05', name: 'ระแงะ', zipcode: '96130' },
  { jw_code: '96', amph_code: '06', name: 'รือเสาะ', zipcode: '96150' },
  { jw_code: '96', amph_code: '07', name: 'ศรีสาคร', zipcode: '96210' },
  { jw_code: '96', amph_code: '08', name: 'แว้ง', zipcode: '96160' },
  { jw_code: '96', amph_code: '09', name: 'สุคิริน', zipcode: '96190' },
  { jw_code: '96', amph_code: '10', name: 'สุไหงโก-ลก', zipcode: '96120' },
  { jw_code: '96', amph_code: '11', name: 'สุไหงปาดี', zipcode: '96140' },
  { jw_code: '96', amph_code: '12', name: 'จะแนะ', zipcode: '96220' },
  { jw_code: '96', amph_code: '13', name: 'เจาะไอร้อง', zipcode: '96130' }
];
const groupby = _.chain(districts)
  .groupBy('jw_code')
  .mapValues(function(v, i) {
    for (var value in v) {
      delete v[value]['jw_code'];
    }
    return v;
  })
  .value();
export default groupby;
